import { render } from "./statistique.vue?vue&type=template&id=0e1d1e6b"
import script from "./statistique.vue?vue&type=script&lang=js"
export * from "./statistique.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LCE\\Documents\\code\\front-end LCE\\centre-sante-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__